/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostImpactByCategoryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostImpactByCategoryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostImpactByCategoryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostImpactByCategoryWidgetConfiguration>): CostImpactByCategoryWidgetConfiguration {
        let obj = Object.assign(new CostImpactByCategoryWidgetConfiguration(), model);
        CostImpactByCategoryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostImpactByCategoryWidgetConfiguration>): CostImpactByCategoryWidgetConfiguration {
        if (!model) return null;
        return CostImpactByCategoryWidgetConfiguration.newInstance(<CostImpactByCategoryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostImpactByCategoryWidgetConfiguration) {
        if (!obj) return;

        models.CostImpactByCategoryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostImpactByCategoryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostImpactByCategoryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Category
     */
    categoryType: models.CategoryType;

}
